var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHpeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hpe_icon_svg__clip0_3859_8766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0V0z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.94 6.19v3.989h14.122V6.19H.94zm13.24 3.121H1.822V7.06H14.18V9.31z",
    fill: "#00B188"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "hpe_icon_svg__clip0_3859_8766"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzM4NTlfODc2NikiPgo8cGF0aCBkPSJNMCAwSDE2VjE2SDBWMFoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0wLjkzOTY5NyA2LjE5MDM0VjEwLjE3OUgxNS4wNjIxVjYuMTkwMzRIMC45Mzk2OTdaTTE0LjE3OTUgOS4zMTExOUgxLjgyMjI1VjcuMDU5NzVIMTQuMTc5NVY5LjMxMTE5WiIgZmlsbD0iIzAwQjE4OCIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzM4NTlfODc2NiI+CjxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";
export { SvgHpeIcon as ReactComponent };